import React from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import SummaryCountCard from './SummaryCountCard';
import { SummaryIcons } from '../icons/SummaryIcons';
import { FilterTypes } from '../enums/SortAndFilterTypes';

const QueueSummary = ({ summary, toggleFilter, filterState }) => {
    return (
        <div className='columns'>
            <div className='column is-one-sixth is-offset-1'>
                <SummaryCountCard loading={!summary} textKey='QueuePage.SortTypes.ReviewDocuments' filterClickedState={filterState.reviewDocuments}
                    count={summary !== null ? Number(summary.document_review) : '-'} onClick={() => toggleFilter(FilterTypes.REVIEW_DOCUMENTS)}>
                    {SummaryIcons.DOCUMENT_REVIEW}
                </SummaryCountCard>
            </div>
            <div className='column is-one-sixth'>
                <SummaryCountCard loading={!summary} textKey='QueuePage.SortTypes.PrepareReturn' filterClickedState={filterState.prepareReturn}
                    count={summary !== null ? Number(summary.prepare_retuen) : '-'} onClick={() => toggleFilter(FilterTypes.PREPARE_RETURN)}>
                    {SummaryIcons.PREPARE_RETURN}
                </SummaryCountCard>
            </div>
            <div className='column is-one-sixth'>
                <SummaryCountCard loading={!summary} textKey='QueuePage.SortTypes.PreparePayment' filterClickedState={filterState.preparePayment}
                    count={summary !== null ? Number(summary.prepare_payment) : '-'} onClick={() => toggleFilter(FilterTypes.PREPARE_PAYMENT)}>
                    {SummaryIcons.PREPARE_PAYMENT}
                </SummaryCountCard>
            </div>
            <div className='column is-one-sixth'>
                <SummaryCountCard loading={!summary} textKey='QueuePage.SortTypes.FileReturn' filterClickedState={filterState.fileReturn}
                    count={summary !== null ? Number(summary.readyToFile): '-'} onClick={() => toggleFilter(FilterTypes.FILE_RETURN)}>
                    {SummaryIcons.FILE_RETURN}
                </SummaryCountCard>
            </div>
            <div className='column is-one-sixth'>
                <SummaryCountCard loading={!summary} textKey='QueuePage.SortTypes.ClientAction' filterClickedState={filterState.clientAction}
                    count={summary !== null ? Number(summary.approvalsPending) : '-'} onClick={() => toggleFilter(FilterTypes.CLIENT_ACTION)}>
                    {SummaryIcons.CLIENT_ACTION}
                </SummaryCountCard>
            </div>
        </div>
    )
}

QueueSummary.propTypes = {
    summary: PropTypes.object,
    toggleFilter: PropTypes.func.isRequired
}

export default QueueSummary